export default "__VITE_ASSET__Bsj2iyEq__"